

























import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import Loading from '@/components/Loading.vue'
import ScorecardSubpage from '@/pages/scorecard/components/ScorecardSubpage.vue'
import {Action, Getter} from 'vuex-class'
import {ScorecardEntity} from '@/entities/scorecard'
import {IResponse} from '@/entities'
import {seeBadge} from '@/api/scorecard'
import {embedded} from '@/utils/react-native-webview'
import ScorecardResponseTile from '@/components/ScorecardResponseTile.vue'

@Component<ScorecardRoomToImproveDetail>({
    components: {ScorecardResponseTile, ScorecardSubpage, Loading}
})
export default class ScorecardRoomToImproveDetail extends Vue {
    @Prop({type: String})
    public value !: string // the room to improve badge

    @Prop({type: String, default: null})
    public teamMemberUserId !: string

    @Getter public slide !: string
    @Getter public scorecard!: ScorecardEntity
    @Getter public scorecardResponsesMap!: { [value: string]: IResponse[] }
    @Getter public scorecardOutdated!: boolean
    @Getter
    hasNetworkConnection!: boolean

    @Action public loadScorecard
    @Action public loadResponsesForBadge

    public get responses() {
        return this.scorecardResponsesMap &&
            this.scorecardResponsesMap[this.mapKey] || []
    }

    public mounted() {
        this.load()
    }

    public get badgeLabel() {
        if (!this.scorecard) {
            return 'Loading...'
        }
        return this.scorecard.badges.negative[this.value].label || this.value
    }

    public get mapKey() {
        return `${this.value}_negative`
    }

    public async load() {
        if (this.scorecardOutdated) {
            await this.loadScorecard(this.teamMemberUserId ?? null)
        }

        if (!this.scorecardResponsesMap || !this.scorecardResponsesMap[this.mapKey]) {
            await this.loadResponsesForBadge({type: 'negative', value: this.value})
        }

        // update the last seen timestamp of this badge
        if (!this.teamMemberUserId && this.scorecard.badges.negative[this.value].countUnseen && this.hasNetworkConnection) {
            await seeBadge(this.value, 'negative')
            this.loadScorecard()

        }
    }

    public get loading() {
        return !this.responses.length
    }

    public get mentionCount() {
        return this.scorecard.badges.negative[this.value].count
    }

    public get embedded() {
        return embedded
    }

}
